// public routes.tsx
import { Outlet, Route } from "react-router-dom";
import { NonAuthenticatedProvider } from "../context/NonAuthenticatedContext";
import ChildProtectionPolicy from "../pages/ChildProtectionPolicy";
import ForgotPassword from "../pages/ForgotPasswordPage";
import { Login } from "../pages/LoginPage";
import PasswordReset from "../pages/PasswordResetPage";

const NonAuthenticatedLayout = () => (
  <NonAuthenticatedProvider>
    <Outlet />
  </NonAuthenticatedProvider>
);

export const PublicRoutes = [
  <Route key={"public-routes"} element={<NonAuthenticatedLayout />}>
    <Route path="/" element={<Login />} />
    <Route path="/forgot-password" element={<ForgotPassword />} />
    <Route path="/password-reset" element={<PasswordReset />} />
    <Route path="/child-safety-standards" element={<ChildProtectionPolicy />} />
  </Route>,
];
